import Style from 'ol/style/Style';
import Text from 'ol/style/Text';
import Fill from 'ol/style/Fill';
import { template } from '@giswebgroup/ki-wcp-base/src/common/util';
import StationsLayer from './StationsLayer';

export default class StationsLabelLayer extends StationsLayer {
  // eslint-disable-next-line class-methods-use-this
  constructor(options) {
    options = {
      declutter: true,
      ...options,
    };
    super(options);
  }

  // eslint-disable-next-line class-methods-use-this
  _getStationStyle(station) {
    return new Style({
      text: new Text({
        font: 'bold 12px "Calibri", "sans-serif"',
        text: template(this.labelTemplate, station),
        textAlign: 'left',
        textBaseline: 'top',
        padding: [0, 0, 0, 0],
        offsetX: 12,
        offsetY: -17 / 2,

        fill: new Fill({ color: 'rgba(25,77,123,1)' }),
        backgroundFill: new Fill({ color: 'rgba(255,255,255,0.8)' }),
      }),
    });
  }

  set labelTemplate(val) {
    this.__labelTemplate = val;
    this.reload();
  }

  get labelTemplate() {
    return this.__labelTemplate || "${station_name}";
  }
}
